import React, { useState } from "react";
import Layouts from "../../Components/Layouts/Layouts";
import axios from "../../axiosinstens";
import "../../styles/LoginStyle.css";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [inputData, setInputData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    cnf_password: "",
  });

  const [loginInputData, setLoginInputData] = useState({
    email: "",
    password: "",
  });

  const handleLoginChange = (e) => {
    setLoginInputData({ ...loginInputData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("organiserLogin", loginInputData);
      if (response.data && response.data.organizer) {
        // Encrypt organizer
        const encryptedOrganizer = CryptoJS.AES.encrypt(
          JSON.stringify(response.data.organizer),
          "secret-organizer-key-seminar"
        ).toString();
        localStorage.setItem("organizer", encryptedOrganizer);
        // token ko localStorage me save karein
        const encrypted = CryptoJS.AES.encrypt(
          response.data.token,
          "secret-key-token-seminar"
        ).toString();
        localStorage.setItem("tokenJwt", encrypted);
        // alert("Login successful!");
        window.location.href = "/seminar";
      }
    } catch (error) {
      console.error("Error logging in:", error);
      alert("Login failed. Please check your credentials.");
    }
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (!validatePassword(inputData.password)) {
      swal(
        "Error",
        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
        "error"
      );
      return;
    }

    if (inputData.password !== inputData.cnf_password) {
      swal("Error", "Passwords do not match.", "error");
      return;
    }

    axios
      .post("organiserRegister", inputData)
      .then((response) => {
        // Encrypt organizer
        const encryptedOrganizer = CryptoJS.AES.encrypt(
          JSON.stringify(response.data.organizer),
          "secret-organizer-key-seminar"
        ).toString();
        localStorage.setItem("organizer", encryptedOrganizer);
        // token ko localStorage me save karein
        const encrypted = CryptoJS.AES.encrypt(
          response.data.token,
          "secret-key-token-seminar"
        ).toString();
        localStorage.setItem("tokenJwt", encrypted);
        navigate("/seminar");
      })
      .catch((error) => {
        console.error("Error registering:", error);
        swal({
          title: "Error",
          text: "Email already exists.",
          icon: "error",
          button: "OK",
        });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  return (
    <>
      <Layouts>
        <section className="login">
          <div className="log-form">
            <div className="logfrmm">
              <div className="loggfrm">
                <h2>Already have an account?</h2>
                <div className="loggfrmm">
                  <h2>Login Now</h2>
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    name="email"
                    value={loginInputData.email}
                    onChange={handleLoginChange}
                  />
                  <input
                    type="password"
                    placeholder="Enter your Password"
                    name="password"
                    value={loginInputData.password}
                    onChange={handleLoginChange}
                  />
                  <button className="loggfrmButton" onClick={handleLogin}>
                    Login
                  </button>
                  <h3 className="reset_password">
                    Having trouble signing in?
                    <Link to="/forgotpassword" className="reset_link">
                      Click here to reset password.
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="linehight">
              <div className="lineimg">
                <img src="assets/images/contact/line.png" alt="line" />
              </div>
            </div>
            <div className="logfrmm">
              <div className="loggfrm">
                <h2>Don't have an account?</h2>
                <h2>Register Now</h2>
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={inputData.name}
                  onChange={handleChange}
                />
                <input
                  type="number"
                  placeholder="Mobile Number"
                  name="phone"
                  value={inputData.phone}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  placeholder="Email ID"
                  name="email"
                  value={inputData.email}
                  onChange={handleChange}
                />
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={inputData.password}
                  onChange={handleChange}
                />
                <p className="message">
                  Password must be at least 8 characters long, contain at least
                  one uppercase letter, one lowercase letter, one number, and
                  one special character.
                </p>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  name="cnf_password"
                  value={inputData.cnf_password}
                  onChange={handleChange}
                />
                <button className="loggfrmButton" onClick={handleRegister}>
                  Register
                </button>
              </div>
            </div>
          </div>
        </section>
      </Layouts>
    </>
  );
}

export default Login;
